import atob from "atob";

const b64toBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data.split(",")[1]);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
export const toDataURL = async (url, token) => {
  let response = await fetch(url, {
    method: "GET"
    // headers: new Headers({
    //   token: token
    // })
  });

  if (response.status !== 200) {
    throw new Error("File Not Found");
  }
  let blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
export default async (uri, name) => {
  try {
    let data = await toDataURL(uri);

    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      b64toBlob(data, `Applicaiton/${uri.split(".").pop()}`),
      { type: `Applicaiton/${uri.split(".").pop()}` }
    );
    a.download = name ? name : `${Date.now()}.${uri.split(".").pop()}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (err) {}
};
